import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_TEXT_SIZE } from './slideConstants';

export function ListSlide({ slide }: SlideProps) {
  let listContent = [];
  if (Array.isArray(slide.data?.content)) {
    listContent = slide.data.content;
  } else if (Array.isArray(slide.data?.items)) {
    listContent = slide.data.items;
  } else if (Array.isArray(slide.data)) {
    listContent = slide.data;
  }
  
  listContent = listContent.filter((item: any) => item != null);

  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center text-left overflow-y-auto max-h-full">
      <ul className="space-y-3 md:space-y-4 w-full">
        {listContent.map((listItem: any, idx: number) => {
          const itemText = typeof listItem === 'string'
            ? listItem
            : JSON.stringify(listItem);

          return (
            <li key={idx} className="flex gap-2 md:gap-3 items-start text-left">
              <span className="text-md md:text-lg text-blue-400 mt-0.5">•</span>
              <Text size={SLIDE_TEXT_SIZE} className="text-white/90 leading-loose text-left text-lg md:text-lg">
                {itemText}
              </Text>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
